export function device() {
  const iPhone = window.navigator.userAgent.includes('iPhone')
  const android = window.navigator.userAgent.includes('Android')

  return iPhone || android ? 'mobile' : 'desktop'
}